import {useCallback, useContext} from 'react';
import {useHistory} from 'react-router';
import {ParamsContext} from './ParamsContext';
import {useCurrentPageType} from './PageTypeContext';
import {usePageTypePathsMap} from './RouterContext';
import {getParams} from './getParams';

/**
 * This re-implements `useParams` from react router so that it is working outside of a route
 */
export const useParams = <Params extends Record<string, string>>(): Params =>
  useContext(ParamsContext) as Params;

export const useParamsCallback = <
  Params extends Record<string, string>,
>(): (() => Params) => {
  const currentPageType = useCurrentPageType();
  const pageTypePathsMap = usePageTypePathsMap();

  const {location} = useHistory();
  return useCallback(() => {
    const pathname = location.pathname;
    return getParams({currentPageType, pageTypePathsMap, pathname});
  }, [currentPageType, location.pathname, pageTypePathsMap]);
};
